/**
 * @fileoverview POST handler for the "/engagement/update_android_notification_channels" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementAndroidNotificationChannelsCacheKeys } from "./constants";
import type { UpdateAndroidNotificationChannelsProps, UpdateAndroidNotificationChannelsResult } from "./types";

export const updateAndroidNotificationChannels = reactQueryMutationAdapter(
  engagementAndroidNotificationChannelsCacheKeys,
  (props: UpdateAndroidNotificationChannelsProps): Promise<UpdateAndroidNotificationChannelsResult> => {
    return fetch(`/engagement/update_android_notification_channels`, "POST", props);
  }
);
